import { PageContainer } from '../../components/PageContainer';
import * as styles from './Welcome.module.css';
import { Button } from '@mui/material';
import { IconInfoCircleFill24 } from 'components/icons/IconInfoCircleFill24';
import { CurrencyLogo } from 'containers/CurrencyLogo';
import { LoginButton } from 'containers/LoginButton';
import wallet from 'images/wallet.png';
import wallet2x from 'images/wallet@2x.png';
import wallet3x from 'images/wallet@3x.png';
import walletPay from 'images/walletPay.png';
import walletPay2x from 'images/walletPay@2x.png';
import walletPay3x from 'images/walletPay@3x.png';
import { useIpCountry } from 'queries/auth/useIpCountry';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, generatePath } from 'react-router-dom';
import { routePaths } from 'router';
import { useAppSelector } from 'store';

export const Welcome: FC = () => {
  const { t } = useTranslation();
  const { tgUser, storeId, jwtToken } = useAppSelector((state) => state.user);

  const { data: ipCountryQuery } = useIpCountry();
  const ipCountry = ipCountryQuery?.data?.toUpperCase();

  return (
    <>
      {ipCountry === 'GB' && (
        <div className="p-4 bg-yellow-400 text-black text-[17px] leading-6 font-medium text-center">
          <IconInfoCircleFill24 className="inline-block mr-4 align-top" />
          {`Walt is unavailable in the UK. You'll need to provide proof of residency outside the UK to use Walt.`}
        </div>
      )}

      <PageContainer adaptive stretch>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.assets}>
              <CurrencyLogo
                currency="TON"
                className="border-4 rounded-full border-white"
              />
              <CurrencyLogo
                currency="USDT"
                className="border-4 rounded-full border-white"
              />
              <CurrencyLogo
                currency="BTC"
                className="border-4 rounded-full border-white"
              />
            </div>
            <h1 className={styles.title}>{t('welcome.title')}</h1>
            <p className={styles.text}>{t('welcome.text')}</p>
            {!tgUser ? (
              <LoginButton />
            ) : (
              <Button
                size="large"
                variant="contained"
                component={Link}
                to={
                  storeId
                    ? generatePath(routePaths.STORE, { id: storeId })
                    : jwtToken
                    ? routePaths.CREATE_STORE
                    : routePaths.ROOT
                }
              >
                {storeId
                  ? t('welcome.go_to_account')
                  : jwtToken
                  ? t('welcome.create_store')
                  : t('welcome.start_wallet')}
              </Button>
            )}
          </div>
          <div className={styles.media}>
            <img
              className={styles.wallet}
              srcSet={`${wallet}, ${wallet2x} 2x, ${wallet3x} 3x`}
              alt="walt"
            />
            <img
              className={styles.walletPay}
              srcSet={`${walletPay}, ${walletPay2x} 2x, ${walletPay3x} 3x`}
              alt="walt pay"
            />
          </div>
        </div>
      </PageContainer>
    </>
  );
};
